var falloffLinearPS = `
float getFalloffLinear(float lightRadius) {
		float d = length(dLightDirW);
		return max(((lightRadius - d) / lightRadius), 0.0);
}
`;

export { falloffLinearPS as default };
